import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import "./index.css"
import { I18nextProvider } from "react-i18next"
import i18next from "i18next"
import { Provider } from "react-redux"
import store from "./store"
import { SnackbarProvider } from "notistack"

import global_es from "./translations/es/global.json"
import global_en from "./translations/en/global.json"

i18next.init({
	interpolation: { escapeValue: false },
	lng: window._env_.REACT_APP_DEFAULT_LANGUAGE ? window._env_.REACT_APP_DEFAULT_LANGUAGE : "en",
	resources: {
		es: {
			global: global_es,
		},
		en: {
			global: global_en,
		},
	},
})

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<I18nextProvider i18n={i18next}>
				<SnackbarProvider maxSnack={Infinity}>
					<App />
				</SnackbarProvider>
			</I18nextProvider>
		</Provider>
	</React.StrictMode>,
	document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
